/**
 * Anchor for the closing call-to-action section.
 *
 * It was `pilot-apply` when that section held an application form for a
 * three-month pilot. Both are gone — the offer is a 30-day trial and the
 * booking happens in cal.com — so the name no longer described anything on
 * the page.
 */
export const BOOK_SECTION_ID = "book-a-call"
